import React from 'react';
import "../App.css";

export default function About() {
    return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
              Hi! I'm Koushik.
            <br className="hidden lg:inline-block" /><div className="title">I aspire to craft solutions<span> that have a meaningful impact.</span></div>
          </h1>
        <p className="mb-8 leading-relaxed">
           I've consistently pursued meaningful challenges throughout my career. My professional journey has been diverse, but my passion for problem-solving and helping others has remained unwavering. I thrive on attention to detail and have an unwavering love for creating. Beyond System operation and Coding, you'll often find me cooking, gardening, spending time with our dog, or enjoying music.
        </p>
      <div className="flex justify-center">
        <a href="#contact"
              className="wrk inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Work With Me
            </a>
            <a
              href="#projects"
              className="wrk2 ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              See My Past Works
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="rightbarAd"
            alt="hero"
            src="./ad.gif"
          />
        </div>
      </div>
    </section>
  );
}
